import { render, staticRenderFns } from "./LicenseDocumentsWidget.vue?vue&type=template&id=0147a848&lang=pug"
import script from "./LicenseDocumentsWidget.vue?vue&type=script&lang=js"
export * from "./LicenseDocumentsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports